import PropTypes from 'prop-types';
import React from 'react';
import { NumberInput as ReactAdminNumberInput, required as requiredFn } from 'react-admin';

export const NumberInput = ({ isRequired, validate, ...props }) => (
  <ReactAdminNumberInput
    {...props}
    validate={isRequired ? requiredFn() : validate}
  />
)

NumberInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  validate: PropTypes.func,
};

NumberInput.defaultProps = {
  sort: false,
  sortable: false,
  alwaysOn: true,
};

export default NumberInput;

